// src/services/dashboard.ts
//
// Dashboard-domain service. Covers the nutritionist dashboard summary stats
// and the paged active-clients list shown on the main dashboard screen.

import { apiFetch } from "../Component/api/apiFetch";
import { API_URLS } from "../Component/api/url";
import { handleJson } from "./http";

export const getDashboardStats = (_nutristId?: string | number): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.GET_DASHBOARD_STATS, { method: "GET" })
  );

export const getTotalActiveClients = (
  nutristId: string | number,
  status: string,
  page: string | number,
  search: string = ""
): Promise<any> =>
  handleJson(
    apiFetch(
      API_URLS.GET_TOTAL_ACTIVE_CLIENTS(nutristId, status, page, search),
      { method: "GET" }
    )
  );
